var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('li',[_c('a',{staticClass:"navlink",class:[isActive && 'active-navlink'],attrs:{"href":href},on:{"click":navigate}},[_vm._t("default"),_c('span',{staticClass:"ml-4"},[_vm._v(" "+_vm._s(_vm.linkProps.name)+" ")])],2)])]}}],null,true)},'router-link',_vm.linkProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }